<template>
  <div class="bgCommon p-2" style="">
    <div
      class="d-flex flex-wrap flex-sm-nowrap justify-content-between align-items-center mt-2 mb-1"
    >
      <div class="d-flex align-items-center">
        <p class="m-0 title-size text-nowrap">交易記錄</p>

        <div class="form-col-select ml-2">
          <v-select
            style="width: 100px"
            v-model="perPage"
            :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            :options="perPageOptions"
            :clearable="false"
            class="per-page-selector d-inline-block"
          />
          <feather-icon size="18" icon="ChevronDownIcon" />
        </div>
      </div>
      <div class="d-flex align-items-center mobile-w100 mt-1 mt-sm-0">
        <div class="search-primary">
          <feather-icon size="16" icon="SearchIcon" />
          <b-form-input
            v-model="searchQuery"
            class="d-inline-block mr-1"
            placeholder="搜尋記錄"
          />
        </div>
      </div>
    </div>
    <b-card no-body class="card-statistics p-1 p-sm-0">
      <b-card-body class="">
        <b-table
          ref="refRecordListTable"
          class="position-relative in_bg2"
          :items="fetchRecords"
          responsive
          :fields="tableColumns"
          primary-key="id"
          :sort-by.sync="sortBy"
          show-empty
          empty-text="未找到匹配的記錄"
          :sort-desc.sync="isSortDirDesc"
        >
          <!-- Column: remark -->
          <template #cell(remark)="data">
            <div class="d-flex text-nowrap align-items-center">
              <span class="mr-1" v-if="data.item.remark.indexOf('搜尋') >= 0">
                <feather-icon
                  class=""
                  size="16"
                  icon="SearchIcon"
                ></feather-icon>
              </span>

              <span class="mr-1" v-if="data.item.remark.indexOf('抽奬') >= 0">
                <feather-icon class="" size="16" icon="GiftIcon"></feather-icon>
              </span>
              <span
                class="mr-1"
                v-if="
                  data.item.remark.indexOf('PayPal') >= 0 ||
                  data.item.remark.indexOf('充值') >= 0
                "
              >
                <feather-icon
                  class=""
                  size="16"
                  icon="DollarSignIcon"
                ></feather-icon>
              </span>
              <span class="mr-1" v-if="data.item.remark.indexOf('子帳戶') >= 0">
                <feather-icon class="" size="16" icon="UserIcon"></feather-icon>
              </span>

              <span>
                {{ data.item.remark }}
              </span>
            </div>
          </template>

          <!-- Column: amount -->
          <template #cell(amount)="data">
            <span
              >{{ Math.sign(data.item.amount) !== -1 ? "+" : ""
              }}{{ data.item.amount }}</span
            >
          </template>

          <!-- Column: create time -->
          <template #cell(created_at)="data">
            {{ getCorrectDateTime(data.item.created_at) }}
          </template>
        </b-table>
        <div class="mx-2 mb-2">
          <b-row>
            <b-col
              cols="12"
              sm="6"
              class="d-flex align-items-center justify-content-center justify-content-sm-start"
            >
              <span class="text-muted"
                >在{{ dataMeta.of }}個記錄中，正在顯示 {{ dataMeta.from }} 至
                {{ dataMeta.to }} 個記錄</span
              >
            </b-col>
            <!-- Pagination -->
            <b-col
              cols="12"
              sm="6"
              class="d-flex align-items-center justify-content-center justify-content-sm-end"
            >
              <b-pagination
                v-model="currentPage"
                :total-rows="totalRecords"
                :per-page="perPage"
                first-number
                last-number
                class="mb-0 mt-1 mt-sm-0"
                prev-class="prev-item"
                next-class="next-item"
              >
                <template #prev-text>
                  <feather-icon icon="ChevronLeftIcon" size="18" />
                </template>
                <template #next-text>
                  <feather-icon icon="ChevronRightIcon" size="18" />
                </template>
              </b-pagination>
            </b-col>
          </b-row>
        </div>
      </b-card-body>
    </b-card>
  </div>
</template>

<script>
import {
  BCard,
  BCardHeader,
  BCardTitle,
  BCardText,
  BCardBody,
  BFormInput,
  BButton,
  BRow,
  BCol,
  BTable,
  BPagination,
} from "bootstrap-vue";
import vSelect from "vue-select";

import useRecordsList from "./useRecordsList";

export default {
  components: {
    BRow,
    BCol,
    BFormInput,
    BButton,
    BCard,
    BCardHeader,
    BCardTitle,
    BCardText,
    BCardBody,
    BTable,
    BPagination,
    vSelect,
  },
  data() {
    return {
      loading: false,
    };
  },
  methods: {},
  setup() {
    const {
      fetchRecords,
      tableColumns,
      perPage,
      currentPage,
      totalRecords,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refRecordListTable,
      refetchData,
      ability,
    } = useRecordsList();

    return {
      // Sidebar
      fetchRecords,
      tableColumns,
      perPage,
      currentPage,
      totalRecords,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refRecordListTable,
      refetchData,
      ability,
    };
  },
};
</script>
<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>
